module.exports = "<p>hc-wellbeing works!</p>\n"